import React from "react";

//Import Breadcrumb
import { Checkbox, FormControlLabel, FormHelperText } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";

const CheckBox = ({ title, error, onChange, required, label, values, disabled, padding, margin, labelMarginLeft, fontSize = 16, color = "#1D1B1B" }) => {

    const checkIcon = () => {
        return (
            <div style={{ backgroundColor: '#1D1B1B', borderRadius: 3, border: '2px solid #1D1B1B', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', width: 18, height: 18, }}>
                <Icon icon={'fluent:checkmark-12-filled'} style={{ color: 'white', margin: 0, padding: 0, height: 12, width: 12}} />
            </div>
        )
    }

    return (
        <React.Fragment>
            <FormControlLabel control={<Checkbox
                error={error ? true : false}
                checked={values || false}
                disabled={disabled}
                checkedIcon={checkIcon()}
                icon={<div style={{width: 18, height: 18, borderRadius: 5, border: '2px solid #1D1B1B'}}></div>}
                onChange={(e) => onChange(e)}
                sx={{
                    '&.Mui-checked': {
                        color: "#1D1B1B",
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: 20,
                    },
                    padding: padding && padding,
                    margin: margin && margin,
                }}
            />} label={<div style={{ color: color && color, marginLeft: labelMarginLeft, fontSize: fontSize}}>{label}</div>} />
            {error && <FormHelperText sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={16} width={16} />{error || ""}</FormHelperText>}


            {/* <Stack direction={"row"} alignItems={"center"}>
                <Radio
                    sx={{
                        '&.Mui-checked': {
                            color: "#009aff",
                        },
                    }}
                    checked={values}
                    onChange={(e) => onChange(e)}
                    value={label}
                    name="radio-buttons"
                />

                <FormLabel className="mb-0">{label}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>
            </Stack> */}


        </React.Fragment >
    );
};

export default CheckBox;
